module.exports = __webpack_public_path__ + "img/webcam.123a4465.svg";